type TExitClick = {
    href: string
    /** A modified or `target`-ed click leaves this document alive, so no `pagehide` follows it. */
    opensTab: boolean
}

export const readNextjsExitClick = (event: MouseEvent): TExitClick | null => {
    if (event.defaultPrevented || event.altKey) {
        return null
    }

    if (event.button !== 0 && event.button !== 1) {
        return null
    }

    const { target } = event

    if (!(target instanceof Element)) {
        return null
    }

    const anchor = target.closest('a[href]')

    if (!anchor) {
        return null
    }

    const href = anchor.getAttribute('href') ?? ''

    if (!href) {
        return null
    }

    const anchorTarget = anchor.getAttribute('target')

    return {
        href,
        opensTab:
            event.button === 1 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            Boolean(anchorTarget && anchorTarget !== '_self'),
    }
}
